module.exports = __webpack_public_path__ + "img/DSC_2684-xs.6f877623.png";